import { render, staticRenderFns } from "./IntentProjects.vue?vue&type=template&id=4a39b294&scoped=true"
import script from "./IntentProjects.vue?vue&type=script&lang=js"
export * from "./IntentProjects.vue?vue&type=script&lang=js"
import style0 from "./IntentProjects.vue?vue&type=style&index=0&id=4a39b294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39b294",
  null
  
)

export default component.exports